import { Healthcard } from 'interfaces';
import { buildHealthcard } from '../../factories';
import { canonicalHealthcards } from '../../factories/seeds/entities';

export const mockHealthcards: Healthcard[] = canonicalHealthcards.map(
  (healthcard) =>
    buildHealthcard<Healthcard>({
      ...healthcard,
      patient: undefined,
    }) as Healthcard
);
